var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6E7882",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1457 4.14719C14.3405 3.95152 14.6571 3.95087 14.8528 4.14573C15.0484 4.34058 15.0491 4.65717 14.8542 4.85283L11.4497 8.27144C10.8778 8.8458 9.95295 8.86184 9.36139 8.30767L5.71212 4.88906C5.5106 4.70027 5.50027 4.38386 5.68906 4.18233C5.87785 3.9808 6.19426 3.97048 6.39579 4.15927L10.0451 7.57788C10.2422 7.7626 10.5505 7.75725 10.7412 7.5658L14.1457 4.14719ZM14.1457 10.6472C14.3405 10.4515 14.6571 10.4509 14.8528 10.6457C15.0484 10.8406 15.0491 11.1572 14.8542 11.3528L11.4497 14.7714C10.8778 15.3458 9.95295 15.3618 9.36139 14.8077L5.71212 11.3891C5.5106 11.2003 5.50027 10.8839 5.68906 10.6823C5.87785 10.4808 6.19426 10.4705 6.39579 10.6593L10.0451 14.0779C10.2422 14.2626 10.5505 14.2573 10.7412 14.0658L14.1457 10.6472Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevron);
export default __webpack_public_path__ + "static/media/double-chevron.c480b4b4663c4a6c4da956c48cae1a88.svg";
export { ForwardRef as ReactComponent };